import { useEffect } from 'react';

import { initCSM } from '../../utils/initCSM';

type AiCornerAgentProps = {
	site?: string;
	siteId?: string;
	widgetId: string;
};

/**
 * Initialises the CSM widget when mounted
 */
export const AiCornerAgent = ({ site, siteId, widgetId }: AiCornerAgentProps) => {
	useEffect(() => {
		initCSM({ site, siteId, widgetId });
	}, [site, siteId, widgetId]);

	return null;
};
